import { useMutation } from '@tanstack/react-query';
import { useFiscalDocuments } from 'scenes/Producer/FiscalDocuments/context';
import { cdfService } from 'v2/services/cdfService';
import uploadService from 'v2/services/upload';

import { useLoadFiles } from './useLoadFiles';

export const useFiscalDocumentsQuickView = () => {
  const { selectedData } = useFiscalDocuments();
  const { refetch } = useLoadFiles(selectedData?.id);

  const uploadMutation = useMutation({
    mutationFn: (args: Parameters<typeof uploadService.uploadFile>) => uploadService.uploadFile(...args),
    onSuccess: () => {
      refetch();
    }
  });

  const downloadMutation = useMutation({
    mutationFn: (id: number) => cdfService.urlDownload(id),
    onSuccess: ({ data }) => {
      window.open(data[0].url, '_blank');
    }
  });

  const upload = (file: File) => {
    uploadMutation.mutate([file, 'doc_fiscais', null, selectedData?.id]);
  };

  const download = (id: number) => {
    downloadMutation.mutate(id);
  };

  return {
    upload,
    uploadIsPending: uploadMutation.isPending,
    download,
    downloadIsPending: downloadMutation.isPending
  };
};
